import { createSlice } from '@reduxjs/toolkit';
import {api} from "../utils/gashtaltAPI";
const token = localStorage.getItem('token');
const user = localStorage.getItem('user');
const initialState = {
    isLoggedIn: !!token,
    user: user ? JSON.parse(user) : null, // Get user info from localStorage
    token: token || null
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        login: (state, action) => {
            api.defaults.headers.common['Authorization'] = `Bearer ${action.payload.token}`;
            state.user = action.payload.user;
            state.token = action.payload.token;
            state.isLoggedIn = true;
            localStorage.setItem('token', action.payload.token);
            localStorage.setItem('user', JSON.stringify(action.payload.user));

        },
        updateName(state, action) {
            state.user = action.payload;
            localStorage.setItem('user', JSON.stringify(action.payload));
        },
        logout: (state) => {
            api.defaults.headers.common['Authorization'] = ``;
            state.user = null;
            state.token = null;
            state.isLoggedIn = false;
            localStorage.removeItem('token');
            localStorage.removeItem('user');
        },
        verifyUser: (state) => {
            if (state.user) {
                state.user.verified = true;
                localStorage.setItem('user', JSON.stringify(state.user));
            }
        },
    },
});

export const { login,updateName, logout,verifyUser } = userSlice.actions;

export default userSlice.reducer;
